import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams, useRouteMatch } from "react-router-dom";
import {
  getPatientByIdRequest,
  toggleActivationRequest,
} from "../PatientsApiActions";
import { useStyles } from "./styles";
import BreadcrumbNav, { getBreadcrumbData } from "./components/BreadcrumbNav";
import PatientProfileContainer from "./components/PatientProfileContainer";

/**
 * function to render patient profile
 * @param location: location from router
 * @returns {JSX.Element}
 * @constructor
 */
const PatientProfile = ({
  location,
  getPatientById,
  patient,
  toggleActivation,
}) => {
  const classes = useStyles();
  const params = useParams();
  const match = useRouteMatch();
  const [
    openToggleActivationConfirmationDialog,
    setOpenToggleActivationConfirmationDialog,
  ] = useState(false);
  const currentUrlPath = match.path.split(":")[0];

  useEffect(() => {
    getPatientById(params.id).then((res) => {});
  }, [params.id, getPatientById]);

  return (
    <Box className={classes.outerContainer}>
      <BreadcrumbNav
        breadcrumbData={getBreadcrumbData(
          currentUrlPath,
          location,
          patient,
          params
        )}
        classes={classes}
        location={location}
      />

      <Box mt={3}>
        {patient && (
          <>
            <PatientProfileContainer
              patient={patient}
              classes={classes}
              match={match}
              location={location}
              params={params}
              onToggleActivationClick={() =>
                setOpenToggleActivationConfirmationDialog(true)
              }
            />
          </>
        )}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    patient: state.patients.patient,
    org: state.organisations.org,
    dept: state.departments.dept,
  };
};

const mapDispatchToProp = (dispatch) => {
  return {
    getPatientById: (id) => {
      return dispatch(getPatientByIdRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    toggleActivation: (id, data) => {
      return dispatch(toggleActivationRequest(id, data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProp)(PatientProfile);
